<template>
    <div class="container  trafficAnalysis_wrap">

        <p class="page_title">트래픽 분석</p>

        <section class="section sec1">
            <div class="sec_titbox">
                <div class="leftbox">
                    <p class="tit">앱 통계</p>
                </div>
                <div class="rightbox"></div>
            </div>
            <div class="card_box">
                <div class="card user">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/traffic_icon1.png`" alt="" class="icon">
                        <span class="txt">활성화 사용자</span>
                    </div>
                    <div class="desc_box">
                        이번 달
                        <span class="data">60,000명</span>
                    </div>
                </div>
                <div class="card">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/traffic_icon2.png`" alt="" class="icon">
                        <span class="txt">애플 앱스토어</span>
                    </div>
                    <div class="desc_box">
                        <button type="button" class="view_btn">통계 보러가기</button>
                    </div>
                </div>
                <div class="card">
                    <div class="tit_box">
                        <img :src="`${$STATIC_URL}/admin/img/traffic_icon3.png`" alt="" class="icon">
                        <span class="txt">구글플레이</span>
                    </div>
                    <div class="desc_box">
                        <button type="button" class="view_btn">통계 보러가기</button>
                    </div>
                </div>
            </div>
        </section>

        <section class="section sec2">
            <div class="sec_titbox">
                <div class="leftbox">
                    <p class="tit">활성 사용자</p>
                </div>
                <div class="rightbox">
                    <div class="filter_box">
                        <button type="button" id="chart1_daybtn" class="filter_btn day on">일별</button>
                        <button type="button" id="chart1_monthbtn" class="filter_btn month">월별</button>
                    </div>
                </div>
            </div>
            <div class="chart_box">
                <div class="chart_top">
                    <div class="select_box">
                        <select class="select">
                            <option value="">8월</option>
                            <option value="">9월</option>
                            <option value="">10월</option>
                            <option value="">11월</option>
                            <option value="">12월</option>
                        </select>
                    </div>
                    <div class="input_box date">
                        <input type="text" placeholder="날짜 선택" class="input_text datepicker" readonly
                            value="2024-08-01 ~ 2024-08-07">
                    </div>
                    <button type="button" class="btn ver2 reset_btn">
                        <span class="icon"></span>
                        <span class="txt">초기화</span>
                    </button>
                </div>
                <div class="chart">
                    <canvas id="chart2" width="1432" height="400"></canvas>
                </div>
            </div>
        </section>

        <div class="section_wrap">
            <div class="leftarea">
                <section class="section sec3">
                    <div class="sec_titbox">
                        <div class="leftbox">
                            <p class="tit">상위 최다 접속 페이지 (10위)</p>
                        </div>
                        <div class="rightbox"></div>
                    </div>
                    <div class="tbl_wrap">
                        <table class="tbl">
                            <thead>
                                <tr>
                                    <th>No.</th>
                                    <th>타이틀</th>
                                    <th>링크 주소</th>
                                    <th>접속 횟수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="num">01</td>
                                    <td class="title">
                                        <span class="bold">
                                            이용권 안내 (INEAR AI 영어말하기평가 솔루션)
                                        </span>
                                    </td>
                                    <td class="url">
                                        <a href="inear.io/service/my_lounge" class="link" taget="_blank">
                                            inear.io/service/my_lounge
                                        </a>
                                    </td>
                                    <td class="connection">
                                        73
                                    </td>
                                </tr>
                                <tr>
                                    <td class="num">02</td>
                                    <td class="title">
                                        <span class="bold">
                                            이용권 안내 (INEAR AI 영어말하기평가 솔루션)
                                        </span>
                                    </td>
                                    <td class="url">
                                        <a href="inear.io/service/my_lounge" class="link" taget="_blank">
                                            inear.io/service/my_lounge
                                        </a>
                                    </td>
                                    <td class="connection">
                                        73
                                    </td>
                                </tr>
                                <tr>
                                    <td class="num">03</td>
                                    <td class="title">
                                        <span class="bold">
                                            이용권 안내 (INEAR AI 영어말하기평가 솔루션)
                                        </span>
                                    </td>
                                    <td class="url">
                                        <a href="inear.io/service/my_lounge" class="link" taget="_blank">
                                            inear.io/service/my_lounge
                                        </a>
                                    </td>
                                    <td class="connection">
                                        73
                                    </td>
                                </tr>
                                <tr>
                                    <td class="num">04</td>
                                    <td class="title">
                                        <span class="bold">
                                            이용권 안내 (INEAR AI 영어말하기평가 솔루션)
                                        </span>
                                    </td>
                                    <td class="url">
                                        <a href="inear.io/service/my_lounge" class="link" taget="_blank">
                                            inear.io/service/my_lounge
                                        </a>
                                    </td>
                                    <td class="connection">
                                        73
                                    </td>
                                </tr>
                                <tr>
                                    <td class="num">05</td>
                                    <td class="title">
                                        <span class="bold">
                                            이용권 안내 (INEAR AI 영어말하기평가 솔루션)
                                        </span>
                                    </td>
                                    <td class="url">
                                        <a href="inear.io/service/my_lounge" class="link" taget="_blank">
                                            inear.io/service/my_lounge
                                        </a>
                                    </td>
                                    <td class="connection">
                                        73
                                    </td>
                                </tr>
                                <tr>
                                    <td class="num">06</td>
                                    <td class="title">
                                        <span class="bold">
                                            이용권 안내 (INEAR AI 영어말하기평가 솔루션)
                                        </span>
                                    </td>
                                    <td class="url">
                                        <a href="inear.io/service/my_lounge" class="link" taget="_blank">
                                            inear.io/service/my_lounge
                                        </a>
                                    </td>
                                    <td class="connection">
                                        73
                                    </td>
                                </tr>
                                <tr>
                                    <td class="num">07</td>
                                    <td class="title">
                                        <span class="bold">
                                            이용권 안내 (INEAR AI 영어말하기평가 솔루션)
                                        </span>
                                    </td>
                                    <td class="url">
                                        <a href="inear.io/service/my_lounge" class="link" taget="_blank">
                                            inear.io/service/my_lounge
                                        </a>
                                    </td>
                                    <td class="connection">
                                        73
                                    </td>
                                </tr>
                                <tr>
                                    <td class="num">08</td>
                                    <td class="title">
                                        <span class="bold">
                                            이용권 안내 (INEAR AI 영어말하기평가 솔루션)
                                        </span>
                                    </td>
                                    <td class="url">
                                        <a href="inear.io/service/my_lounge" class="link" taget="_blank">
                                            inear.io/service/my_lounge
                                        </a>
                                    </td>
                                    <td class="connection">
                                        73
                                    </td>
                                </tr>
                                <tr>
                                    <td class="num">09</td>
                                    <td class="title">
                                        <span class="bold">
                                            이용권 안내 (INEAR AI 영어말하기평가 솔루션)
                                        </span>
                                    </td>
                                    <td class="url">
                                        <a href="inear.io/service/my_lounge" class="link" taget="_blank">
                                            inear.io/service/my_lounge
                                        </a>
                                    </td>
                                    <td class="connection">
                                        73
                                    </td>
                                </tr>
                                <tr>
                                    <td class="num">10</td>
                                    <td class="title">
                                        <span class="bold">
                                            이용권 안내 (INEAR AI 영어말하기평가 솔루션)
                                        </span>
                                    </td>
                                    <td class="url">
                                        <a href="inear.io/service/my_lounge" class="link" taget="_blank">
                                            inear.io/service/my_lounge
                                        </a>
                                    </td>
                                    <td class="connection">
                                        73
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
            <div class="rightarea">
                <section class="section sec4">
                    <div class="sec_titbox">
                        <div class="leftbox">
                            <p class="tit">상위 최다 접속 페이지 (10위)</p>
                        </div>
                        <div class="rightbox"></div>
                    </div>
                    <div class="lanking_box">
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">1</span>
                                <span class="tit">Organic Search</span>
                            </div>
                            <div class="desc_box">145회</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">2</span>
                                <span class="tit">Organic Search</span>
                            </div>
                            <div class="desc_box">145회</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">3</span>
                                <span class="tit">Organic Search</span>
                            </div>
                            <div class="desc_box">145회</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">4</span>
                                <span class="tit">Organic Search</span>
                            </div>
                            <div class="desc_box">145회</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">5</span>
                                <span class="tit">Organic Search</span>
                            </div>
                            <div class="desc_box">145회</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">6</span>
                                <span class="tit">Organic Search</span>
                            </div>
                            <div class="desc_box">145회</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">7</span>
                                <span class="tit">Organic Search</span>
                            </div>
                            <div class="desc_box">145회</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">8</span>
                                <span class="tit">Organic Search</span>
                            </div>
                            <div class="desc_box">145회</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">9</span>
                                <span class="tit">Organic Search</span>
                            </div>
                            <div class="desc_box">145회</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">10</span>
                                <span class="tit">Organic Search</span>
                            </div>
                            <div class="desc_box">145회</div>
                        </div>
                    </div>
                </section>
                <section class="section sec5">
                    <div class="sec_titbox">
                        <div class="leftbox">
                            <p class="tit">상위 최다 플래폼 (Referral 기준)</p>
                        </div>
                        <div class="rightbox"></div>
                    </div>
                    <div class="lanking_box">
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">1</span>
                                <span class="tit">inface.ai</span>
                            </div>
                            <div class="desc_box">12</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">2</span>
                                <span class="tit">inface.ai</span>
                            </div>
                            <div class="desc_box">12</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">3</span>
                                <span class="tit">inface.ai</span>
                            </div>
                            <div class="desc_box">12</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">4</span>
                                <span class="tit">inface.ai</span>
                            </div>
                            <div class="desc_box">12</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">5</span>
                                <span class="tit">inface.ai</span>
                            </div>
                            <div class="desc_box">12</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">6</span>
                                <span class="tit">inface.ai</span>
                            </div>
                            <div class="desc_box">12</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">7</span>
                                <span class="tit">inface.ai</span>
                            </div>
                            <div class="desc_box">12</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">8</span>
                                <span class="tit">inface.ai</span>
                            </div>
                            <div class="desc_box">12</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">9</span>
                                <span class="tit">inface.ai</span>
                            </div>
                            <div class="desc_box">12</div>
                        </div>
                        <div class="item">
                            <div class="tit_box">
                                <span class="num">10</span>
                                <span class="tit">inface.ai</span>
                            </div>
                            <div class="desc_box">12</div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

    </div>
</template>
<script setup>
</script>
<style scoped>
.dashboard_wrap .card_box > .card .tit_box{
    flex-direction: unset !important;
    padding: unset !important;
}
.dashboard_wrap .card_box > .card .tit_box::after{
    content: unset !important;
    width: unset !important;
    height: unset !important;
    background: unset !important;
    display: unset !important;
    margin: unset !important;
}
.dashboard_wrap .card_box > .card .desc_box{
    padding: unset !important;
    display: unset !important;
}
.leftarea{
    width: 1024px !important;
}
.rightarea{
    width: calc(100% - 1024px - 24px) !important;
}
</style>